import { render, staticRenderFns } from "./GameRatingForm.vue?vue&type=template&id=5e7ed63e&scoped=true&"
import script from "./GameRatingForm.vue?vue&type=script&lang=ts&"
export * from "./GameRatingForm.vue?vue&type=script&lang=ts&"
import style0 from "./GameRatingForm.vue?vue&type=style&index=0&id=5e7ed63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7ed63e",
  null
  
)

export default component.exports